import { formatPhone } from './phone';
import { ILocation } from '../../../types/location';

interface IPrepareInitialValues {
  location: ILocation;
  userPhone: string | null;
}

export const prepareInitialValues = ({ location, userPhone }: IPrepareInitialValues) => {
  return {
    region: {
      id: location.id,
      label: location.displayName,
    },
    phone: userPhone ? formatPhone(userPhone) : '',
  };
};
